import { CheckCircle } from '@mui/icons-material'
import {
  Card,
  CardActionArea,
  CardContent,
  colors,
  Stack,
  styled,
  Typography,
} from '@mui/material'

import type { TransformedEmailNotificationData } from '@/lib/apollo/query/getEmailNotifications'
import { formatDate } from '@/utils/date'

export interface Props {
  notifications: TransformedEmailNotificationData[]
  selectedNotification?: string
  onSelectNotification?: (notificationId: string | undefined) => void
}

const selectedCardBackground = colors.lightBlue[100]

const StyledCard = styled(Card)<{ isSelected: boolean }>`
  background: ${({ isSelected }) => (isSelected ? selectedCardBackground : 'inherit')};
`

const EmailNotifications = ({
  notifications,
  selectedNotification,
  onSelectNotification,
}: Props) => {
  return (
    <div>
      {notifications.length === 0 ? (
        <Typography>No emails found.</Typography>
      ) : (
        <Stack direction="column" spacing={2}>
          {notifications.map(notification => (
            <StyledCard
              key={notification.id}
              isSelected={notification.id === selectedNotification}
            >
              <CardActionArea
                onClick={() =>
                  onSelectNotification?.(
                    notification.id !== selectedNotification
                      ? notification.id
                      : undefined,
                  )
                }
              >
                <CardContent>
                  <Typography variant="body1">Email subject:</Typography>
                  <Typography variant="h6" mb={1}>
                    {notification.subject}
                  </Typography>
                  <Stack direction="row" justifyContent="space-between" spacing={2}>
                    <Typography variant="body2">
                      Sent: {formatDate(notification.sentDate, 'dd/MM/yyyy HH:mm')}
                    </Typography>
                    {notification.id === selectedNotification && (
                      <CheckCircle color="primary" />
                    )}
                  </Stack>
                </CardContent>
              </CardActionArea>
            </StyledCard>
          ))}
        </Stack>
      )}
    </div>
  )
}

export default EmailNotifications
